import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../supabase/supabase';

const ImageContext = createContext();

const TABLE_NAME = 'site_settings_1740050000000';
const DEFAULT_HERO = "https://images.unsplash.com/photo-1583947581924-860bda6a26df?q=80&w=2000&auto=format&fit=crop";
const DEFAULT_GALLERY = [
  { url: 'https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=800&auto=format&fit=crop', label: 'Wedding', rotation: '-rotate-2' },
  { url: 'https://images.unsplash.com/photo-1530103862676-de8892b07439?q=80&w=800&auto=format&fit=crop', label: 'Birthday', rotation: 'rotate-3' },
  { url: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?q=80&w=800&auto=format&fit=crop', label: 'Bar Mitzvah', rotation: '-rotate-1' },
  { url: 'https://images.unsplash.com/photo-1559027615-cd9431872199?q=80&w=800&auto=format&fit=crop', label: 'Fundraiser', rotation: 'rotate-2' }
];

export const ImageProvider = ({ children }) => {
  const [images, setImages] = useState({ hero: DEFAULT_HERO, gallery: DEFAULT_GALLERY });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const { data, error } = await supabase
        .from(TABLE_NAME)
        .select('*');

      if (data && data.length > 0) {
        const hero = data.find(s => s.key === 'hero_image')?.value || DEFAULT_HERO;
        const gallery = data.find(s => s.key === 'gallery_images')?.value || DEFAULT_GALLERY;
        setImages({ hero, gallery });
      }
    } catch (err) {
      console.error("Error fetching settings:", err);
    } finally {
      setLoading(false);
    }
  };

  const updateHero = async (url) => {
    setImages(prev => ({ ...prev, hero: url }));
    try {
      await supabase
        .from(TABLE_NAME)
        .upsert({ key: 'hero_image', value: url }, { onConflict: 'key' });
    } catch (err) {
      console.error("Error updating hero:", err);
    }
  };

  const updateGallery = async (index, url) => {
    const newGallery = [...images.gallery];
    newGallery[index] = { ...newGallery[index], url };
    setImages(prev => ({ ...prev, gallery: newGallery }));
    
    try {
      await supabase
        .from(TABLE_NAME)
        .upsert({ key: 'gallery_images', value: newGallery }, { onConflict: 'key' });
    } catch (err) {
      console.error("Error updating gallery:", err);
    }
  };

  const resetToDefault = async () => {
    if (window.confirm("Are you sure you want to reset all images to defaults?")) {
      setImages({ hero: DEFAULT_HERO, gallery: DEFAULT_GALLERY });
      try {
        await supabase.from(TABLE_NAME).upsert([
          { key: 'hero_image', value: DEFAULT_HERO },
          { key: 'gallery_images', value: DEFAULT_GALLERY }
        ]);
      } catch (err) {
        console.error("Error resetting defaults:", err);
      }
    }
  };

  return (
    <ImageContext.Provider value={{ images, updateHero, updateGallery, resetToDefault, loading }}>
      {children}
    </ImageContext.Provider>
  );
};

export const useImages = () => useContext(ImageContext);